export const APP_NAME = 'OpenCare';
export const APP_TAGLINE = 'Lås- og tilgangsadministrasjon';
export const APP_BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER || 'local';

